import FundFiller from "./Subpages/FundFiller/FundFiller";
import Emails from "./Subpages/Emails/Emails";
import DssReport from "./Subpages/DssReports/DssReports";
import DssSavers from "./Subpages/DssSavers/DssSavers";
import Publishing from "./Subpages/Publishing/Publishing";

const Dashboard = {

    init() {
        this.el = $('[page="Dashboard"]');

        if (!this.el.length) {
            return;
        }

        this.start();
    },

    start() {
        FundFiller.init();
        DssSavers.init();
        Emails.init();
        DssReport.init();
        Publishing.init();
    }
}
export default Dashboard;